/**
 * Module dependencies.
 */

import { omit, reduce } from 'lodash';

/**
 * Normalize single object.
 */

export function normalizeSingleObject(item) {
  if (Array.isArray(item)) {
    return item.map((obj) => {
      return normalizeSingleObject(obj);
    });
  }

  const result = {
    ...omit(item, ['translations']),
  };

  reduce(
    item.translations,
    (acc: any, item: any) => {
      const language = item.languages_code.code.split('-')[0];

      delete item.languages_code;

      for (const key of Object.keys(item)) {
        if (!acc[key]) {
          acc[key] = {};
        }

        acc[key][language] = item[key];
      }

      return acc;
    },
    result,
  );

  return result;
}

/**
 * Normalize list.
 */

export function normalizeList(data) {
  return data.map(normalizeSingleObject);
}
